import { Component, OnInit, ViewChild } from "@angular/core";
import { LoggerService } from "src/shared/logger/logger.service";
import { Levels } from 'src/shared/logger/levels.enum';
import { endpoint } from "../../shared/endpoints.model";
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmationComponent } from "src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component";
import { timeZones } from "./timeZones";
import { NgForm } from "@angular/forms";

@Component({
  selector: 'system-update',
  templateUrl: './update.system.component.html',
  styleUrls: ['update.system.component.css']
})

export class SystemUpdateComponent implements OnInit {

  endpoint_data_received: endpoint;
  endpoint_data_ToBe_Edited: endpoint;
  keysToBeChecked = ["system_name", "sip_display_name", "system_time_zone", "dns_server1", "dns_server2", "dns_server3",
    "ntp_server1", "sip_proxy_address", "sip_proxy_address2", "sip_registration_uri", "sip_listen_port", "sip_tls_verify",
    "h323_gatekeeper_address", "dns_domain_name", "sip_authentication_username", "sip_authentication_password",
    "enable_h323", "enable_sip", "h323_e164", "h323_id"]
  availableTimeZones = timeZones;
  onAndOffOptions: string[] = ["Off", "On"]
  checkedAuthenticationPassword: boolean = false;
  @ViewChild('ff') submitForm: NgForm;
  pushingToSystemFlag: boolean = false;

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.systemService.endpointDateToBeTransmitted.subscribe(data => {
      this.endpoint_data_received = data;
      this.endpoint_data_ToBe_Edited = Object.assign({}, this.endpoint_data_received);
    });
  }

  openDialog(): void {
    let systemToBeDeleted = { id: this.endpoint_data_received.id, name: this.endpoint_data_received.system_name, ip: this.endpoint_data_received.system_ip }
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Delete system", message: `Are you sure you want to delete system with name = ${systemToBeDeleted.name} and ip = ${systemToBeDeleted.ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.deleteSystem(systemToBeDeleted);
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onSubmitData() {
    if (this.submitForm.valid && !this.pushingToSystemFlag) {
      this.pushingToSystemFlag = true;
      let dataChanged: { key: string, newVal: string }[] = [];
      dataChanged = this.checkAndGetChangedData();
      if (dataChanged.length > 0 && this.endpoint_data_received.is_provisioned && this.endpoint_data_received.system_password) {
        this.systemService.updateProfile(this.endpoint_data_received.system_ip,
          this.endpoint_data_received.software_version, dataChanged).subscribe(data => {
            // this.endpoint_data_received = data["message"];
            // this.endpoint_data_ToBe_Edited = Object.assign({}, this.endpoint_data_received);
            this.pushingToSystemFlag = false;
            data["message"].enable_phonebook = data["message"].enable_phonebook == '1' ? "On" : "Off"
            data["message"].enable_sip = data["message"].enable_sip == '1' ? "On" : "Off"
            data["message"].enable_h323 = data["message"].enable_h323 == '1' ? "On" : "Off"
            this.systemService.endpointDateToBeTransmitted.next(data["message"]);
            this.loggerService.log("SystemUpdateComponent", `Data were pushed for unit with id =${this.endpoint_data_received.id}`, Levels.info)
            this.openSnackBar('Data push is completed', "Success");
          }, err => {
            this.loggerService.log("SystemUpdateComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
            this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
            this.pushingToSystemFlag = false;
          })
      } else {
        this.pushingToSystemFlag = false;
      }
    }
  }

  checkAndGetChangedData(): { key: string, newVal: string }[] {
    let dataChanged: { key: string, newVal: string }[] = [];
    for (let keyToBeChecked of this.keysToBeChecked) {
      if (this.endpoint_data_received[keyToBeChecked] != this.endpoint_data_ToBe_Edited[keyToBeChecked]) {
        if (keyToBeChecked == "sip_authentication_password") {
          if (!this.checkedAuthenticationPassword || this.endpoint_data_ToBe_Edited[keyToBeChecked] == "***"
            || this.endpoint_data_ToBe_Edited[keyToBeChecked].length < 6) { continue; }
        }
        dataChanged.push({ key: keyToBeChecked, newVal: this.endpoint_data_ToBe_Edited[keyToBeChecked] })
      }
    }
    return dataChanged
  }

  openDialogPush(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Push to System", message: `Are you sure you want to push configuration to system with name = ${this.endpoint_data_received.system_name} and ip = ${this.endpoint_data_received.system_ip}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onSubmitData();
      }
    });
  }
}
